import { InjectionToken } from '@angular/core';
import type { GridPlugin } from '../interfaces/grid-context.types';

/**
 * Multi-token de descoberta de plugins. Cada diretiva de plugin se registra com
 * `providers: [{ provide: GRID_PLUGIN, useExisting: <PluginConcreto> }]`, permitindo que o
 * Host descubra plugins heterogêneos via `contentChildren(GRID_PLUGIN)` sem conhecer os
 * tipos concretos (Registry Pattern aplicado à descoberta de plugins).
 */
export const GRID_PLUGIN = new InjectionToken<GridPlugin>('GRID_PLUGIN');
